'use strict';

module.exports = function (ngModule) {
    ngModule.directive('sevReplace', require('./sevreplace'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/sevreplace/index.js
 **/